import { fork, all, call } from 'redux-saga/effects';
import { initialize } from './app.saga-services';

import { watchAuthSaga } from './auth/auth.saga-watchers';
import { watchSupportSaga } from './support/support.saga-watchers';
import { watchDialogSaga } from './dialog/dialog.saga-watchers';
import { watchPageSaga } from './page/page.saga-watchers';
import { pusherUserSagaWatcher } from './socket/pusher/pusher-user.saga-watcher';
import { pusherMeetingSagaWatcher } from './socket/pusher/pusher-meeting.saga-watchers';

export function* appSagaWatcher() {
  yield all(
    [
      watchAuthSaga,
      watchSupportSaga,
      watchDialogSaga,
      watchPageSaga,
      pusherUserSagaWatcher,
      pusherMeetingSagaWatcher,
    ].map(fork),
  );

  yield call(initialize);
}
